import React, { useRef } from "react";
import "./Form.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import InputMask from "react-input-mask";
import emailjs from "@emailjs/browser";

const Form = () => {
  const { register,  setValue } = useForm();
  
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "gmailMessage",
        "jotav-email",
        form.current,
        "q5N5VLx4eRn6UXwHW"
      )
      .then(
        (result) => {
          setValue("name", "");
          setValue("email", "");
          setValue("message", "");

          toast.success('Parabéns! Em breve entraremos em contato');
        },
        (error) => {
          toast.error('erro! Mande um whatsapp');
        }
      );
  };

    return (
      <div className="Form">
        <form ref={form} className="form-group" onSubmit={sendEmail}>
          <input
            {...register("nome")}
            id="name"
            name="name"
            className="form-control mb-3 mt-3"
            placeholder="Nome"
            required
          />
          <input
            {...register("email")}
            id="email"
            name="email"
            className="form-control mb-3"
            placeholder="E-mail"
            required
          />
          <InputMask
            mask="(99)99999-9999"
            {...register("telefone")}
            id="message"
            name="message"
            className="form-control mb-3"
            placeholder="Whatsapp"
            required
          />
          <button type="submit" className="btn btn-lg btn-block botao-entrar ">
            Fale Agora
          </button>
        </form>
      </div>
    );
};


export default Form;
